document.addEventListener('DOMContentLoaded', function () {
  // find all Groceries mega menus
  document.querySelectorAll('.mega-menu--groceries').forEach(function(menu){
    var leftItems = menu.querySelectorAll('.mega-left-list li[data-child]');
    if (!leftItems.length) return;

    function activateItem(item) {
      var handle = item.getAttribute('data-child');
      // left
      leftItems.forEach(function(li){ li.classList.remove('active'); });
      item.classList.add('active');
      // center panels
      menu.querySelectorAll('.mega-center-panel').forEach(function(panel){
        if (panel.getAttribute('data-child') === handle) {
          panel.classList.add('active');
        } else {
          panel.classList.remove('active');
        }
      });
    }

    // initial: ensure first is active
    activateItem(leftItems[0]);

    // desktop hover & keyboard focus
    leftItems.forEach(function(li){
      li.addEventListener('mouseenter', function(){ if(window.innerWidth >= 900) activateItem(li); });
      li.addEventListener('focus', function(){ activateItem(li); }, true);
      // mobile: click to activate (prevent immediate navigation if clicking left label)
      li.addEventListener('click', function(e){
        if (window.innerWidth < 900) {
          var a = li.querySelector('a');
          // prevent redirect on first tap — make this tap activate
          if (a && !li.classList.contains('active')) {
            e.preventDefault();
            activateItem(li);
            return false;
          }
          // if already active, allow link navigation
        }
      });
    });

    // close panels when details closes (for accessibility)
    var details = menu.closest('details');
    if (details) {
      details.addEventListener('toggle', function(){
        if (!details.open) {
          // reset to first
          activateItem(leftItems[0]);
        }
      });
    }

    // click outside to close details (optional behavior)
    document.addEventListener('click', function(e){
      if (!menu.contains(e.target)) {
        var parentDetails = menu.closest('details');
        if (parentDetails && parentDetails.open) parentDetails.open = false;
      }
    });
  });
});
